import request from './request';

const paymentProcessService = {
  get: (params) => request.get('dashboard/admin/payment-process', { params }),
  getAll: (params) =>
    request.get('dashboard/admin/payment-process', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/payment-process/${id}`, {
      params,
    }),
};

export default paymentProcessService;
